import React from 'react'

import { SvgProps } from '../../model/types'

const DownloadIcon: React.FC<SvgProps> = props => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			className="download-icon"
			fill="currentColor"
			{...props}
		>
			<path d="M16.6667 12.5C17.1269 12.5 17.5 12.8731 17.5 13.3333V16.6667C17.5 17.5872 16.7538 18.3333 15.8333 18.3333H4.16667C3.24619 18.3333 2.5 17.5872 2.5 16.6667V13.3333C2.5 12.8731 2.8731 12.5 3.33333 12.5C3.79357 12.5 4.16667 12.8731 4.16667 13.3333V16.6667H15.8333V13.3333C15.8333 12.8731 16.2064 12.5 16.6667 12.5ZM10 1.66666C10.4602 1.66666 10.8333 2.03976 10.8333 2.49999V11.0355L12.9462 8.92257C13.2717 8.59707 13.7993 8.59707 14.1247 8.92257C14.4502 9.24799 14.4502 9.77566 14.1247 10.1011L10.7366 13.4892C10.3297 13.8961 9.67025 13.8961 9.26342 13.4892L5.87521 10.1011C5.54977 9.77566 5.54977 9.24799 5.87521 8.92257C6.20065 8.59707 6.72828 8.59707 7.05372 8.92257L9.16667 11.0355V2.49999C9.16667 2.03976 9.53975 1.66666 10 1.66666Z" />
		</svg>
	)
}

export default DownloadIcon
